export default __webpack_public_path__ + "static/media/proban.27f8157a.jpg";